import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { APP_ID } from "../../_app/consts";

export interface AppSettings {
  orderCompleted: boolean;
  showChart: boolean;
}

const getInitialShowChart = (): boolean => {
  const storedValue = localStorage.getItem("viewChart" + APP_ID);
  return storedValue === "false" ? false : true;
};

// Начальное состояние
const initialState: AppSettings = {
  orderCompleted: false,
  showChart: getInitialShowChart(),
};

const userSlice = createSlice({
  name: "appSettings",
  initialState,
  reducers: {
    orderCompleted: (state) => {
      state.orderCompleted = true;
    },
    toggleChart: (state, action: PayloadAction<boolean>) => {
      state.showChart = action.payload;
    },
  },
});

// Экспортируем экшены
export const { orderCompleted, toggleChart } = userSlice.actions;

// Экспортируем редьюсер
export default userSlice.reducer;
